<template>
  <div id="page1">
    <el-row style="margin-top: 10%;">
      <el-col :span="24"><div class="avatar" />
        <img src="img/Avatar.jpg" id="avatar" style="border-radius:50%; width: 20%" @click="switchStatus">
      </el-col>
    </el-row>
    <br><br><br>
    <el-row>
      <el-col :span="24"><div class="username"/>
        <span style="font-weight: bolder; font-size: 60px; font-family: 'Arial Hebrew'; ">
        {{name}}
      </span>
      </el-col>
    </el-row>
    <br>
    <el-row>
      <el-col :span="24"><div class="username"/>
        <span style="font-weight: normal; font-size: 20px; font-family: 'Arial Hebrew'; ">
        {{ mortal }}
      </span>
      </el-col>
    </el-row>
  </div>
  <img id="down" src="img/down.png" class="image" style="margin-top: 10%;width: 5%; height: 5%;margin-bottom: 5%">
</template>

<script>
export default {
  name: "pageOne",
  data (){
    return {
      name: "Sun Haoran",
      mortal: "吾生也有涯, 而知也无涯．"
    }
  }
}
</script>

<style scoped>
span{
  color: #303133;
}
#page1{
  animation: fadeIn; /* referring directly to the animation's @keyframe declaration */
  animation-duration: 1s; /* don't forget to set a duration! */
}

#down{
  animation: fadeInUp; /* referring directly to the animation's @keyframe declaration */
  animation-duration: 1s; /* don't forget to set a duration! */
  display: inline;
}

#page1 img:hover {
  transform: scale(1.2);
  transition: all 0.6s;
  cursor: pointer;
}

</style>